"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.getPolicyError = void 0;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DEFAULT_PASSWORD_POLICY = {
  minLength: 6,
  maxLength: 80,
  forbidEmail: true
};
var EMAIL_PASSWORD_SUBSTRING_LENGTH = 3;
var SYMBOL_REGEXP = new RegExp('[^0-9A-Za-z]');
var UPPERCASE_REGEXP = new RegExp('[A-Z]');
var LOWERCASE_REGEXP = new RegExp('[a-z]');
var NUMBER_REGEXP = new RegExp('[0-9]');

var checkEmail = function checkEmail(email, password) {
  if (!email || !password) {
    return false;
  }

  var lcPassword = password.toLowerCase();

  if (email.length <= EMAIL_PASSWORD_SUBSTRING_LENGTH) {
    return lcPassword.includes(email.toLowerCase());
  }

  var chars = email.toLowerCase().split('');

  for (var i = 0; i <= chars.length - EMAIL_PASSWORD_SUBSTRING_LENGTH; i++) {
    if (lcPassword.includes(chars.slice(i, i + EMAIL_PASSWORD_SUBSTRING_LENGTH).join(''))) {
      return true;
    }
  }

  return false;
}; // TODO: replace strings


var getPolicyError = function getPolicyError(intl, policy) {
  return function (name) {
    return intl.formatMessage({
      id: "password_policy_".concat(name)
    }, _defineProperty({}, name, policy[name]));
  };
};

exports.getPolicyError = getPolicyError;

var validate = function validate(intl) {
  var policy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_PASSWORD_POLICY;
  var email = arguments.length > 2 ? arguments[2] : undefined;
  return function (password) {
    var result = null;
    var getError = getPolicyError(intl, policy);

    if (typeof policy.minLength !== 'undefined' && password.length < policy.minLength) {
      result = getError('minLength');
    } else if (typeof policy.maxLength !== 'undefined' && password.length > policy.maxLength) {
      result = getError('maxLength');
    } else if (policy.hasSymbols && !SYMBOL_REGEXP.test(password)) {
      result = getError('hasSymbols');
    } else if (policy.hasUppercase && !UPPERCASE_REGEXP.test(password)) {
      result = getError('hasUppercase');
    } else if (policy.hasLowercase && !LOWERCASE_REGEXP.test(password)) {
      result = getError('hasLowercase');
    } else if (policy.hasNumbers && !NUMBER_REGEXP.test(password)) {
      result = getError('hasNumbers');
    } else if (policy.forbiddenWords && policy.forbiddenWords.find(function (word) {
      return password.toLowerCase().includes(word.toLowerCase());
    })) {
      result = getError('forbiddenWords');
    } else if (policy.forbidEmail && checkEmail(email, password)) {
      result = getError('forbidEmail');
    }

    return result;
  };
};

var _default = validate;
exports.default = _default;